import { create } from 'zustand';

// Runtime-only connection state. Never persisted to an account or browser disk.
export const useBrowserConnectionStore = create(() => ({
  available: false, enabled: false, status: '', pages: [], selected: [], picker: false,
  connect: () => {}, disconnect: () => {}, options: () => {}, list: () => {}, add: () => {},
}));
